<template>
	<div class="top_adv" v-if="adv && webinfo.answer != ''">
		<marquee>
			<a v-if="webinfo.linkUrl == ''">{{ webinfo.answer }}</a>
			<a :href="webinfo.linkUrl" target="_blank" v-else>{{ webinfo.answer }}</a>
		</marquee>
		<div class="close" @click="closeadv"></div>
	</div>
	<div class="top">
		<div class="topTopBox">
			<div class="w1600 clearfix" style="display: flex;
				justify-content: space-between;
				align-items: center;
				flex-wrap: nowrap;
				max-width: 1600px;
				margin: 0 auto;">
				<div class="logo">
					<a href="/"><img :src="$uploadfiles() + webinfo.coverImage" alt="" /></a>
				</div>
				<div class="topBanner">
					<div class="swiper-container" id="topBanner" style="margin-top: -25px;">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item, index) in topBannerList" :key="index">
								<img :src="bindImg(item.coverImage)" alt="" class="top-img" @click="jump(item)">
							</div>
						</div>
					</div>
				</div>
				<div class="rightBox clearfix">
					<!-- <div class="searBox" v-if="topindex == 3">
            <div class="searIpt">
              <input
                v-model="key"
                placeholder="输入关键字"
                @keyup.enter="search"
              />
              <a
                href="javascript:;"
                class="goSear"
                title="搜索"
                @click="search"
              ></a>
            </div>
            <div class="searKey">
              <span>搜索关键词：</span>
              <a
                v-for="item in searchKeywords"
                @click="$pushTo(`/BeforeExam/jumpcurriculum?key=${item.title}`)"
                >{{ item.title }}</a
              >
            </div>
          </div> -->
					<div class="nav_btn" @click="showNav" :class="{ open: responsive }">
						<span></span>
					</div>
					<div class="LoginBx clearfix">
						<div class="napaBox clearfix" v-if="islogin == 0">
							<div class="item name">
								<input type="text" name="" v-model="account" placeholder="用户名" />
							</div>
							<div class="item pasw">
								<input type="password" name="" v-model="password" placeholder="密码" />
							</div>
						</div>
						<div class="btnBox" v-if="islogin == 0">
							<div class="goLog a" :v-loading="submitting" @mouseover="showLogin" @mouseleave="ycLogin">
								<span @click="login"> 登录</span>
								<div class="box" v-show="showlo == 1">
									<a @click="$pushTo(`/BeforeExam/loginPhone`)">手机号码登录</a>
									<a @click="wxLogin">微信扫码登录</a>
								</div>
							</div>
							<a href="javascript:;" @click="$pushTo(`/BeforeExam/register`)">注册</a>
						</div>

						<div class="btnBox" v-if="islogin == 1">
							<div class="perord">
								<div class="personBox" @click="$pushTo(`/BeforeExam/personalCenter`)">个人中心<img
										src="../../assets/images/forward_07.png" alt=""></div>
								<div class="orderBox" @click="$pushTo(`/BeforeExam/memberOrder`)">我的订单<img
										src="../../assets/images/forward_07.png" alt=""></div>
							</div>
							<div class="nameBox" @click="$pushTo(`/BeforeExam/personalCenter`)">
								{{ yonghuname }}
								<div class="name-tx" v-if="form.avatar"><img :src="$bindImg(form.avatar)" alt=""></div>
								<div class="name-tx" v-else><img src="@/assets/uploadfiles/grtx.png" alt=""></div>
							</div>
							<a href="javascript:;" @click="onLogoutClick">登出</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="topBomBox" :class="showTop ? 'istop' : ''">
			<div class="w1600 clearfix">
				<div class="nav" :class="{ show: responsive }">
					<ul class="clearfix">
						<li id="nav1" :class="topindex == '1' ? 'on' : ''">
							<a href="/">首页</a>
						</li>
						<li id="nav2" :class="topindex == '2' ? 'on' : ''">
							<a @click="$pushTo(`/BeforeExam/examBook`)">考试用书</a>
						</li>
						<li id="nav3" :class="topindex == '3' ? 'on' : ''">
							<a @click="$pushTo(`/BeforeExam/curriculum`)">全部课程</a>
						</li>
						<li id="nav6" v-if="islogin == 1" :class="topindex == '6' ? 'on' : ''">
							<a @click="$pushTo(`/BeforeExam/memberCourse`)">视频课程</a>
						</li>
						<!-- <li id="nav6" :class="topindex == '6' ? 'on' : ''">
							<a @click="$pushTo(`/BeforeExam/freeTesting`)">免费测评</a>
						</li> -->
						<li id="nav4" :class="topindex == '4' ? 'on' : ''">
							<a @click="$pushTo(`/BeforeExam/questionBank`)">在线题库</a>
						</li>
						<li id="nav5" :class="topindex == '5' ? 'on' : ''">
							<a @click="$pushTo(`/BeforeExam/freeData`)">学习资料</a>
						</li>
						<li id="nav7" :class="topindex == '7' ? 'on' : ''">
							<a @click="$pushTo(`/BeforeExam/question`)">常见问题</a>
						</li>
						<li id="nav8" v-if="islogin == 1" :class="topindex == '8' ? 'on' : ''">
							<a @click="$pushTo(`/BeforeExam/onlineQuestion`)">在线答疑</a>
						</li>
					</ul>
				</div>
				<a href="javascript:;" @click="$onlineconSultation()" class="seekBtn">我要咨询</a>
			</div>
		</div>
	</div>

	<div class="popup_box show" v-show="xz_pop">
		<div class="layer"></div>
		<div class="userNotice">
			<div class="bg_top">
				<h2>用户须知</h2>
				<p>
					欢迎使用我们的在线学习网站！在使用本网站之前，请您仔细阅读以下须知，以确保您了解并同意我们的条款和条件。
				</p>
			</div>

			<div class="txt_con">
				<h3>1. 网站使用</h3>
				<p>您可以在我们的网站上浏览各种课程信息和内容，但只有注册并登录的用户才能购买课程。未经授权，禁止复制、分发或以其他方式使用本网站的内容。</p>
				<h3>2. 隐私政策</h3>
				<p>我们尊重您的隐私权。在您使用本网站时，我们将收集必要的信息，如姓名、电子邮件地址和支付信息等，以提供更好的服务和用户体验。我们承诺保护您的个人信息，并按照隐私政策处理这些信息。</p>
				<h3>3. 课程购买和退换货</h3>
				<p>购买课程后，您将获得课程访问权限和相关的学习资源。请在购买前仔细阅读课程描述和退换货政策。若您对购买的课程不满意，可在规定时间内申请退换货。请注意，退换货需符合我们的政策要求。</p>
				<h3>4. 课程质量和版权</h3>
				<p>我们保证提供的课程内容准确、完整且符合相关法律法规。未经授权，禁止复制、分享或以其他方式使用课程内容和相关资源。对于侵犯版权的行为，我们将采取适当的法律行动。</p>
				<h3>5. 技术支持</h3>
				<p>在使用本网站时，若遇到任何技术问题，您可以通过电子邮件或电话等方式联系我们的技术支持团队。我们将尽快解决您的问题，但无法保证随时在线解答。</p>
				<h3>6. 网站安全</h3>
				<p>我们非常重视网站的安全性。我们会采取必要的措施保护您的账户和支付信息，但请注意在使用公共网络时保护您的个人信息。对于任何未经授权的访问或使用您的账户的行为，我们将不承担任何责任。</p>
				<h3>7. 法律和管辖</h3>
				<p>本须知受（您的国家/地区）法律的管辖。对于因使用本网站而产生的任何争议，您应首先尝试与我们协商解决。若无法解决，您可以在（您的国家/地区）法院提起诉讼或选择仲裁机构进行仲裁。</p>
			</div>

			<div class="colse_btn" @click="tongyiquren()">同意并确认</div>
		</div>
	</div>
</template>

<script>
import {
	GetCurrLogin,
	LoginByUserName
} from "@/api/student";
import {
	GetPage,
	GetItemById
} from "@/api/content";
import Swiper from "swiper";

export default {
	components: {
		Swiper,
	},
	data() {
		return {
			adv: true,
			showlo: 0,
			form: {},
			webinfo: {},
			islogin: 1,
			account: "",
			yonghuname: "",
			password: "",
			submitting: false,
			responsive: false,
			key: "",
			searchKeywords: [],
			showTop: false,

			xz_pop: false,
			topBannerList: [],
		};
	},
	props: {
		//接收父组件传来的值
		topindex: String,
		url: String,
	},
	created() {
		this.setCurrAdmin();
		this.loadinfo();
		GetPage({
			pageIndex: 1,
			pageSize: 3,
			filter: JSON.stringify({
				columnId: 18,
				enable: true
			}),
			sign: this.$sign(),
		}).then((res) => {
			this.searchKeywords = res.body.items;
		}).catch((err) => {
			console.log(err);
		});

		GetPage({
			pageIndex: 1,
			pageSize: 20,
			filter: JSON.stringify({
				columnId: 44,
				enable: true
			}),
		}).then((res) => {
			this.topBannerList = res.body.items;

			this.$nextTick(() => {
				new Swiper("#topBanner", {
					slidesPerView: 1,
					observer: true,
					observeParents: true,
					pagination: {
						el: "#topBanner .swiper-pagination",
					},
					navigation: {
						nextEl: "#topBanner .swiper-button-next",
						prevEl: "#topBanner .swiper-button-prev",
					},
					paginationClickable: true,
					autoplay: true,
					loop: true,
				});
			});
		}).catch((err) => {
			console.log(err);
		});
	},
	mounted() {
		window.addEventListener("scroll", this.scrolling);

		// new Swiper("#topBanner", {
		//   slidesPerView: 1,
		//   spaceBetween: 30,
		//   loop: true, // Enable looping of slides
		//   autoplay: {
		//     delay: 3000, // Set the delay between slides in milliseconds
		//     disableOnInteraction: false, // Allow manual navigation to override autoplay
		//   },
		// });
	},
	methods: {
		jump(item) {
			if (item.linkUrl != null && item.linkUrl != "") {
				this.$pushTo(item.linkUrl);
			}
		},
		bindImg(img) {
			let that = this
			// if (img.indexOf('http') > -1) {
			//   return img;
			// }
			return that.$uploadfiles() + img;
		},
		tongyiquren() {
			if (this.url == "" || this.url == undefined) {
				this.$pushTo("/BeforeExam/personalCenter");
			} else {
				this.$pushTo(decodeURIComponent(this.url));
			}
		},
		scrolling() {
			let current =
				document.documentElement.scrollTop || document.body.scrollTop;
			if (current > 30) {
				this.showTop = true;
			} else {
				this.showTop = false;
			}
		},
		loadinfo() {
			var that = this;
			GetItemById({
				columnId: 23,
			}).then((res) => {
				that.webinfo = res.body;
			}).catch((err) => {
				console.log('loadinfo', err);
			});
		},
		// 顶部广告
		closeadv() {
			this.adv = !this.adv;
		},
		search() {
			let that = this;
			if (that.key.length == 0) {
				that.$errorMessage("请输入搜索关键字");
				return;
			}
			that.$pushTo("/BeforeExam/jumpcurriculum?key=" + that.key);
		},
		showNav() {
			this.responsive = !this.responsive;
		},
		login() {
			var that = this;
			if (that.account == "") {
				this.$errorMessage("请输入用户名");
				return;
			}
			if (that.password == "") {
				this.$errorMessage("请输入密码");
				return;
			}

			this.submitting = true;

			LoginByUserName({
				password: that.password,
				username: that.account,
			}).then((res) => {
				this.submitting = false;

				let token = res.body;
				localStorage.setItem("studenttoken", token.token.tokenStr);
				localStorage.setItem("studenttoken_expires", token.token.expires);
				localStorage.setItem("studenttoken_uniqueKey", token.token.uniqueKey);

				that.xz_pop = true
			}).catch((err) => {
				this.submitting = false;

				if (err.body.yzmLogin) {
					that.$errorMessage(err.body.msg,3000);
					that.account = "";
					that.password = "";
					that.$pushTo(`/BeforeExam/loginCode`);
				}
				//console.log('test',err);
			});
		},
		onLogoutClick() {
			this.$confirm(
				this.$t("personalInfo.confirmLogout"),
				this.$t("common.tip"), {
				type: "warning",
			}).then(() => {
				localStorage.removeItem("studenttoken");
				this.$pushTo("/BeforeExam/loginPhone");
				this.islogin = 0;
			}).catch(() => {
				console.log("退出登录失败");
			});
		},
		setCurrAdmin() {
			GetCurrLogin({
				tokenStr: localStorage.getItem("studenttoken"),
				siteId: 1,
			}).then((res) => {
				//console.log(res.body);
				this.form = res.body;
				console.log("form", this.form);
				if (this.form.title == "") {
					this.yonghuname = this.form.account;
				} else {
					this.yonghuname = this.form.title;
				}
				if (this.form == "") {
					this.islogin = 0;
				} else {
					this.islogin = 1;
				}
			}).catch((err) => {
				this.islogin = 0;
			});
		},
		showLogin() {
			this.showlo = 1;
		},
		ycLogin() {
			this.showlo = 0;
		},
		wxLogin() {
			var that = this
			let UA = navigator.userAgent.toLocaleLowerCase();
			console.log(that.$WxCallBack())
			if (UA.indexOf("micromessenger") !== -1) {
				const appid = 'wxea46b6056a29eac4';
				const redirectUri = encodeURIComponent(that.$WxCallBack());
				const authUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid +
					"&redirect_uri=" + redirectUri +
					"&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
				window.location.href = authUrl;

			} else {
				that.$pushTo(`/BeforeExam/loginScan`);
			}
		}
	},
};
</script>


<style lang="scss" scoped></style>